import React, { useState, useEffect } from 'react';
import Seccion from './Seccion';
import Button from '../../../components/common/Button';
import CuotasFormaPago from './CuotasFormaPago';
import { FaTimes } from "react-icons/fa";

const Paquete = ({ paquetes, formaPago,cuotas,actualizarCuotas, quitarPaquete, quitarSeccion, quitarAccion, costoUbicacion, areaIntervenir, actualizarCosto }) => {
    const [totalesPaquetes, setTotalesPaquetes] = useState({});
    const [totalGeneral, setTotalGeneral] = useState(0);

    useEffect(() => {
        const nuevosTotales = {};
        let totalGeneralTemp = 0;

        paquetes.forEach((paquete) => {
            const totalPaquete = paquete.secciones.reduce((acumulador, seccion) => {
                const totalSeccion = seccion.acciones.reduce((acc, accion) => {
                    return acc + (accion.montoTotal || 0);
                }, 0);
                return acumulador + totalSeccion;
            }, 0);

            nuevosTotales[paquete.id] = totalPaquete.toFixed(2);
            totalGeneralTemp += totalPaquete; // Suma al total general
        });

        setTotalesPaquetes(nuevosTotales);
        setTotalGeneral(totalGeneralTemp.toFixed(2)); // Actualiza el total general
    }, [paquetes, areaIntervenir, costoUbicacion]);

    return (
        <>
            {paquetes.map((paquete) => (
                <div key={paquete.id} className="bg-blue-400 max-w-sm w-full rounded-lg shadow-lg mb-6">
                    {/* Header del paquete */}
                    <div className="flex items-center justify-between pt-1 px-2">
                        <div>
                            <h2 className="text-xl font-semibold text-white">{paquete.paquete}</h2>
                            <p className="text-white text-sm mt-1">{paquete.descripcion}</p>
                        </div>
                        <div className="text-right">
                            <span className="text-white text-lg font-semibold">{totalesPaquetes[paquete.id] || '0.00'}</span>
                        </div>
                        <Button
                            onClick={() => quitarPaquete(paquete.id)}
                            type="delete"
                            texto={<FaTimes />}
                        />
                    </div>

                    {/* Secciones dentro del paquete */}
                    <div className="mt-2">
                        {paquete.secciones.map((seccion) => (
                            <Seccion
                                key={seccion.id}
                                seccion={seccion}
                                paqueteId={paquete.id}
                                quitarAccion={quitarAccion}
                                quitarSeccion={quitarSeccion}
                                costoUbicacion={costoUbicacion}
                                areaIntervenir={areaIntervenir}
                                actualizarCosto={actualizarCosto}
                            />
                        ))}
                    </div>

                    {/* Forma de Pago */}
                    <div>
                        <CuotasFormaPago 
                            total={totalesPaquetes[paquete.id] || '0.00'} 
                            metodoPago={formaPago} 
                            paqueteId={paquete.id} 
                            cuotas={cuotas}
                            actualizarCuotas={actualizarCuotas}
                        />
                    </div>
                </div>
            ))}
        </>
    );
};

export default Paquete;
